import React, { useEffect, useState } from 'react';
import BannerSectionStyle9 from '../Section/BannerSection/BannerSectionStyle9';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import { pageTitle } from '../../helpers/PageTitle';
import { API_URL } from '../../Config/environment';
import { getAllBlogs } from '../../Api/blog';
import { getAllArticles } from '../../Api/article';
import ArticleSectionStyle from '../Section/ArticleSection/ArticleSectionStyle';
import Seo from '../../helpers/Seo';


export default function Article() {
  const [articleData, setArticleData] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log("articleData", articleData);
  pageTitle('Article');

  function mapToPostItems(apiArticles) {
    return apiArticles.map((article) => ({
      title: article.title,
      thumbUrl: `${API_URL}/uploads/healthArticles/${article.imageUrl[0]}`,
      date: new Date(article.createdAt).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      }),
      btnText: "Read more",
      href: `/article/${article.id}`,
      socialShare: true,
    }));
  }

  useEffect(() => {
    async function fetchArticles() {
      try {
        setLoading(true);
        const apiArticles = await getAllArticles();
        const newmap = mapToPostItems(apiArticles?.articles)
        setArticleData(newmap);
      } catch (err) {
        console.error("Error fetching article:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchArticles();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <Seo
        title="Article"
        description="Read latest healthcare articles"
        // image="/article.jpg"
        url="https://gkcklinica.com/article"
        keywords="health tips, medical blog, doctors advice, healthcare articles"
      />
      <Section topMd={150}
        topLg={70}
        topXl={50}>
        <Section topMd={170} bottomMd={96} bottomLg={70}>
          <Breadcrumb title="Article" />
        </Section>
        <Section bottomMd={200} bottomLg={150} bottomXl={110}>
          <ArticleSectionStyle data={articleData} />
        </Section></Section>

    </>
  );
}
